<template>
    <div id="div1">
        <div id="div4">
            <div id="div2">
                <img src="../../assets/img/home/15.png" alt="">
                <img src="../../assets/img/home/16.png" alt="">
                <img src="../../assets/img/home/17.png" alt="">
                <img src="../../assets/img/home/18.png" alt="">
                <img src="../../assets/img/home/19.png" alt="">
                <img src="../../assets/img/home/20.png" alt="">
            </div>
            <div id="div3"></div>
            <!--这个容器是用来防止图片滚动时会出现空白的区域-->
        </div>
    </div>
</template>
<script>
    export default{
        data(){
            return{

            }
        },
        mounted(){
            window.onload = function () {
                var v1 = document.getElementById('div1');
                var v2 = document.getElementById('div2');
                var v3 = document.getElementById('div3');
                v3.innerHTML = v2.innerHTML;//将v2容器里面的图片插入到v3容器里面  使其空白区域被遮住。
                function fun() {
                    if (v3.offsetWidth - v1.scrollLeft <= 0) {
                        v1.scrollLeft -= v2.offsetWidth;
                    } else {
                        v1.scrollLeft++;
                    }
                }
                var fun1 = setInterval(fun, 40);
            }
        }
    }
</script>
<style type="text/css" scoped>
    img {
        margin: 0;
        padding: 0;
    }

    img {
        float: left;
        width: 1rem;
        height: 1.4rem;    
        margin-right: 10px;
    }

    #div1 {
        width: 100%;
        height: 1.4rem;
        overflow: hidden;
        margin-top: 0.07rem;
    }

    #div2,
    #div3 {
        float: left;
    }
    #div4 {
        width: 5000%;
        /*这个属性很重要 让容器有足够的宽度实现滚动*/
        float: left;
    }
</style>


// WEBPACK FOOTER //
// src/views/common/one.vue